<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.keywords" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>
<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="联系人姓名">-->
<!--              <a-input v-model="queryParam.name" placeholder="搜索联系人姓名"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="省级审核">-->
<!--              <a-select v-model="queryParam.sstatus" placeholder="请选择"-->
<!--                        allowClear>-->
<!--                <a-select-option value="2">等待审核</a-select-option>-->
<!--                <a-select-option value="1">审核成功</a-select-option>-->
<!--                <a-select-option value="3">审核失败</a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <template v-if="advanced && false">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="申报时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
<!--      <a-button @click="download(2)" style="margin-left: 8px">-->
<!--        申报人员导出表-->
<!--        <a-icon type="download"/>-->
<!--      </a-button>-->

      <a-dropdown v-if="  selectedRowKeys.length > 0 && false">
        <a-menu slot="overlay">
          <a-menu-item @click="onCenterDeleteAll" key="1">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="float: left">
            {{ record.danwei }}
            <br/>
            编号:{{record.code}}
            <br/>
            联系人:{{ record.name }} <span style="color: #999">手机:{{ record.phone }}</span>
            <br/>
            <span style="color: #999">身份证:{{ record.num }}</span>
            <br/>
             等级:{{ record.grade }} 项目:{{record.project}}
          </div>
      </span>

      <span slot="status" slot-scope="text,record">
           <span v-if="record.status==1" style="color:green">审核通过</span>
        <span v-if="record.status==2" style="color:red">待审核</span>
        <span v-if="record.status==3" style="color:#cccccc">审核不通过</span>
      </span>
      <span slot="sstatus" slot-scope="text,record">
           <span v-if="record.status==1" style="color:green">审核通过</span>
        <span v-if="record.status==2" style="color:red">待审核</span>
        <span v-if="record.status==3" style="color:#cccccc">审核不通过</span>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
            <a @click="handleDownload(record, 1)">下载证书</a>
<!--          <a-divider type="vertical"/>-->
<!--            <a @click="handleDownload(record, 2)">打包资料</a>-->
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                <a-input readonly v-decorator="[
          'danwei'
        ]"
                         placeholder="请输入单位"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="编号"
                  hasFeedback

              >
                <a-input v-decorator="[
          'code',
          {rules: [{ required: true, message: '请输入编号' }]}
        ]"
                         placeholder="请输入编号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入姓名' }]}
        ]"
                         placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-input v-decorator="[
          'sex',
          {rules: [{ required: true, message: '请输入性别' }]}
        ]"
                         placeholder="请输入性别"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48" v-if="false">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="民族"
                  hasFeedback
              >
                <a-input v-decorator="[
          'minzu']"
                         placeholder="请输入民族"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="生日"
                  hasFeedback
              >
                <a-input v-decorator="[
          'birthday',
          {rules: [{ required: true, message: '请输入生日' }]}
        ]"
                         placeholder="请输入联系人手机"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24" v-if="false">
              <a-form-item
                  label="个人证件照"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <pic-uploader
                    :file-list="formData.zhengjianimg"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
          'num',
          {rules: [{ required: true, message: '请输入身份证' }]}
        ]"
                         placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系电话"
                  hasFeedback
              >
                <a-input v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入联系电话' }]}
        ]"
                         placeholder="请输入联系人手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="邮箱"
                  hasFeedback
              >
                <a-input v-decorator="[
          'email',
          {rules: [{ required: true, message: '请输入邮箱' }]}
        ]"
                         placeholder="请输入邮箱"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="通级比赛名次"
                  hasFeedback

              >
                <a-input v-decorator="[
          'bisaichengji'
        ]"
                         placeholder="请输入通级比赛名次"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="通级比赛时间"
                  hasFeedback

              >
                <a-input v-decorator="[
          'bisaidate'
        ]"
                         placeholder="请输入通级比赛时间"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="通级比赛地点"
                  hasFeedback

              >
                <a-input v-decorator="[
          'bisaididian'
        ]"
                         placeholder="请输入通级比赛地点"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="个人测试成绩"
                  hasFeedback

              >
                <a-input v-decorator="[
          'chengji'
        ]"
                         placeholder="请输入个人测试成绩"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="个人测试时间"
                  hasFeedback

              >
                <a-input v-decorator="[
          'chengjidate'
        ]"
                         placeholder="请输入个人测试时间"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="个人测试地点"
                  hasFeedback
              >
                <a-input v-decorator="[
          'chengjididian'
        ]"
                         placeholder="请输入个人测试地点"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48" v-if="false">
            <a-col :md="12" :sm="24">
              <a-form-item label="已有技术等级"  :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
                <a-select v-model="formData.oldgrade" placeholder="请选择"
                          allowClear>
                  <a-select-option value="无">无</a-select-option>
                  <a-select-option value="一星级">一星级</a-select-option>
                  <a-select-option value="二星级">二星级</a-select-option>
                  <a-select-option value="三星级">三星级</a-select-option>
                  <a-select-option value="四星级">四星级</a-select-option>
                  <a-select-option value="五星级">五星级</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="已有项目"  :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
                <a-select v-model="formData.oldproject" placeholder="请选择"
                          allowClear>
                  <a-select-option value="无">无</a-select-option>
                  <a-select-option value="花球啦啦操">花球啦啦操</a-select-option>
                  <a-select-option value="街舞啦啦操">街舞啦啦操</a-select-option>
                  <a-select-option value="技巧啦啦操">技巧啦啦操</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item label="申报技术等级"  :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
                <a-select v-model="formData.grade" placeholder="请选择"
                          allowClear>
                  <!--                <a-select-option value="无">无</a-select-option>-->
                  <a-select-option value="一星级">一星级</a-select-option>
                  <a-select-option value="二星级">二星级</a-select-option>
                  <a-select-option value="三星级">三星级</a-select-option>
                  <a-select-option value="四星级">四星级</a-select-option>
                  <a-select-option value="五星级">五星级</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="申报项目"  :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
                <a-select v-model="formData.project" placeholder="请选择"
                          allowClear>
                  <!--                <a-select-option value="无">无</a-select-option>-->
                  <a-select-option value="花球啦啦操">花球啦啦操</a-select-option>
                  <a-select-option value="街舞啦啦操">街舞啦啦操</a-select-option>
                  <a-select-option value="技巧啦啦操">技巧啦啦操</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48" v-if="false">
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="身份证照片"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <pic-uploader
                    :file-list="formData.pic"
                />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  label="上传相关证明材料"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <file-uploader
                    :file-list="formData.attsrc"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48" v-if="false">
            <a-col :md="12" :sm="24">
              <a-form-item label="近三年啦啦操参赛成绩" :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
                <a-textarea :row="2" v-decorator="[ 'jianli']" placeholder="从事啦啦操运动简历和主要运动成绩..."/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider v-if="false">审核信息</a-divider>
          <a-row :gutter="48" v-if="false">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="省级审核状态"
                  hasFeedback
              >
                <a-radio-group v-model="formData.sstatus" buttonStyle="solid">
                  <a-radio-button :value="2">待审核</a-radio-button>
                  <a-radio-button :value="1">审核通过</a-radio-button>
                  <a-radio-button :value="3">审核失败</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

<!--          <a-row :gutter="48">-->
<!--            <a-col :md="48" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="{-->
<!--          xs: { span: 12 },-->
<!--          sm: { span: 4 }}"-->
<!--                  :wrapperCol="{-->
<!--          xs: { span: 24 },-->
<!--          sm: { span: 12 }}"-->
<!--                  label="审核状态"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-radio-group v-model="formData.status" buttonStyle="solid">-->
<!--                  <a-radio-button :value="2">待审核</a-radio-button>-->
<!--                  <a-radio-button :value="1">审核通过</a-radio-button>-->
<!--                  <a-radio-button :value="3">审核失败</a-radio-button>-->
<!--                </a-radio-group>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->

<!--          <a-row :gutter="48">-->
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item label="审核失败理由" :labelCol="labelCol"-->
<!--                           :wrapperCol="wrapperCol">-->
<!--                <a-textarea :row="2" v-decorator="[ 'adminnote']" placeholder="审核失败理由..."/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {
  getLevelSpApplyMemberList,
  getLevelSpApplyMemberDetail,
  editLevelSpApplyMember,
  deleteLevelSpApplyMember,
  getCenterDownloadUrl
} from '@/api/yundongyuan'
import setting from "@/config/setting";

export default {
  name: 'LevelApplyMemberList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      saveLoading: false,
      formData: {
        id: 0,
        name: '',
        num: '',
        danwei: '',
        namekey: '',
        province: '',
        city: '',
        county: '',
        sex: '',
        minzu: '',
        pic: [],
        attsrc: [],
        phone: '',
        email: '',
        bisaidate: '',
        bisaididian: '',
        bisaichengji: '',
        chengjidate: '',
        chengjididian: '',
        chengji: '',
        oldgrade: '',
        oldproject: '',
        grade: '',
        project: '',
        jianli: ''
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        // {
        //   title: '省审状态',
        //   dataIndex: 'sstatus',
        //   scopedSlots: {customRender: 'sstatus'},
        // },
        // {
        //   title: '国审状态',
        //   dataIndex: 'status',
        //   scopedSlots: {customRender: 'status'},
        // },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        // this.queryParam.namekeys = []
        // this.queryParam.danwei = ''
        // this.queryParam.kaoji_jiameng_type = ''
        // this.queryParam.kaojiregist_status = 0
        this.queryParam = Object.assign(this.queryParam, parameter);

        console.log(this.queryParam)
        return getLevelSpApplyMemberList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
  },
  methods: {
    moment,
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    handleDownload(record, index) {
      if (index == 1) {
        window.open(record.pdf_url)
      } else {
        window.open(record.file_url)
      }
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getLevelSpApplyMemberDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit', res.data.namekey)

          res.data.namekeys = [res.data.namekey.substring(0, 2) + '0000', res.data.namekey.substring(0, 4) + '00', res.data.namekey];
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          self.formData = {...res.data};
        }, 200)
      })
    },

    deleteHandle(record) {
      let self = this
      deleteLevelSpApplyMember({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    onCenterDeleteAll() {
      let self = this
      centerDeleteAll({ids: this.selectedRowKeys}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          // province: '', city: '', county: ''

          self.saveLoading = true;
          editLevelSpApplyMember({
            id: self.formData.id,
            namekey: self.formData.namekeys[self.formData.namekeys.length - 1],
            danwei: values.danwei,
            name: values.name,
            num: values.num,
            code: values.code,
            sex: values.sex,
            minzu: values.minzu,
            pic: self.formData.pic,
            zhengjianimg: self.formData.zhengjianimg,
            attsrc: self.formData.attsrc,
            email: values.email,
            phone: values.phone,
            bisaidate: values.bisaidate,
            bisaididian: values.bisaididian,
            bisaichengji: values.bisaichengji,
            chengjidate: values.chengjidate,
            chengjididian: values.chengjididian,
            chengji: values.chengji,
            oldgrade: self.formData.oldgrade,
            grade: self.formData.grade,
            oldproject: self.formData.oldproject,
            project: self.formData.project,
            jianli: self.formData.jianli,
            adminnote: values.adminnote,
            status: self.formData.status,
            sstatus: self.formData.sstatus,
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },

    download(type) {
      // return
      let params = Object.assign(this.queryParam, {time_range: this.time_range_moment, type: type})
      // console.log('params', params);return
      getCenterDownloadUrl(params)
          .then(res => {
            console.log(res)
            window.open(res.data)
          })
          .catch(err => {
            this.$message.error(err.data.msg)
          })
      return;
      switch (type) {
        case 1:
          // 地区信息表
          window.open(setting.apiBaseURL + '/adminapi/examecenter/centerDownload?saiqu=');
          break;
        case 2:
          // console.log(this.queryParam)
          //   return
          break;
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

  },
  filters: {
    jinduFilter(value) {
      switch (value) {
        case 1:
          return `联系申报单位`;
        case 2:
          return `告知省级并征求意见+申报单位积极准备中`;
        case 3:
          return `申报单位积极准备中`;
        case 4:
          return `条件已具备，等待验收`;
        case 5:
          return `等待全国啦啦操验收`;
        case 6:
          return `验收并授牌`;
        case 7:
          return `同意考试`;
      }
    },
  },
  watch: {}
}
</script>
